import { MyleTableColumn } from "@/Common/Components/Tables/MyleTableColumn";
import { MyPreventiveActionsSortOrderType, SortDirection } from "@/Common/Models/UI/Enums";
import { MyleTableTarget } from "@/Common/Models/UI/Tables/MyleTableTarget";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { PreventiveActivitiesSettingsContainerState } from "@/Portfolio/Components/PreventiveActivitiesSettingsContainer";
import { PortfolioStore } from "@/Portfolio/Stores/PortfolioStore";

class PreventiveActivitiesInboxHandler extends BaseOperationHandler {
    constructor() {
        super();

        this.RegisterOperation(LocalOperations.Portfolio.PreventiveActivitiesInbox_LoadSettingsSearch, this.LoadSettingsSeacrh);
        this.RegisterOperation(LocalOperations.Portfolio.PreventiveActivitiesInbox_SettingsContainerVisibility, this.toggleSettingsPopupVisibility);
        this.RegisterOperation(LocalOperations.Portfolio.PreventiveActivitiesInbox_LoadFromSearch, this.loadFromSearch);
        this.RegisterOperation(LocalOperations.Portfolio.PreventiveActivitiesInbox_ColumnOrderingPopupVisibility, this.visibilityColumnOrderingPopup);
        this.RegisterOperation(LocalOperations.Portfolio.PreventiveActivitiesInbox_SetPage, this.setPage);
        this.RegisterOperation(LocalOperations.Misc.Table_ColumnSortClick, this.setColumnSort);
    }

    private LoadSettingsSeacrh(request: LocalEvent, store: PortfolioStore): void {
        const settings = request.Get<PreventiveActivitiesSettingsContainerState>("settings");
        store.preventiveActivitiesInboxModel = store.preventiveActivitiesInboxModel
            .set("SavedSettingsContainerState", settings)
            .set("CurrentPage", 1);

        portfolioStore.PortfolioActions.loadPreventiveActivities();
    }

    private toggleSettingsPopupVisibility(request: LocalEvent, store: PortfolioStore): void {
        store.preventiveActivitiesInboxModel = store.preventiveActivitiesInboxModel.set("IsSettingsContainerOpen", !store.preventiveActivitiesInboxModel.get("IsSettingsContainerOpen"));
    }

    private loadFromSearch(request: LocalEvent, store: PortfolioStore): void {
        const searchText = request.Get<string>("searchText");
        store.preventiveActivitiesInboxModel = store.preventiveActivitiesInboxModel
            .set("CurrentPage", 1)
            .set("SearchText", searchText);

        portfolioStore.PortfolioActions.loadPreventiveActivities();
    }

    private visibilityColumnOrderingPopup(request: LocalEvent, store: PortfolioStore): void {
        const isOpen = request.Get<boolean>("isOpen");
        store.preventiveActivitiesInboxModel = store.preventiveActivitiesInboxModel
            .set("IsColumnOrderingPopupOpen", isOpen)
            .set("IsSettingsContainerOpen", false);
    }

    private setPage(request: LocalEvent, store: PortfolioStore): void {
        const page = request.Get<number>("Page");
        store.preventiveActivitiesInboxModel = store.preventiveActivitiesInboxModel
            .set("CurrentPage", page);

        portfolioStore.PortfolioActions.loadPreventiveActivities();
    }

    public setColumnSort(request: LocalEvent, store: PortfolioStore): void {
        const sortBy = request.Get<MyPreventiveActionsSortOrderType>("sortColumn");

        if (sortBy === null)
            return;

        const tableTarget = request.Get<MyleTableTarget>("target");
        const column = request.Get<MyleTableColumn>("columnObject");

        if (tableTarget === MyleTableTarget.Myle_PortfolioPreventiveActivities_ColumnSortClick) {
            const prevSortBy = store.preventiveActivitiesInboxModel.get("OrderByColumn");
            const prevSortDir = store.preventiveActivitiesInboxModel.get("OrderByDirection");

            const sortDir = prevSortBy === sortBy && prevSortDir === SortDirection.ASC
                ? SortDirection.DESC
                : SortDirection.ASC;

            store.preventiveActivitiesInboxModel = store.preventiveActivitiesInboxModel
                .set("OrderByColumn", sortBy)
                .set("OrderByDirection", sortDir);

            if (column) {
                if (column.columnOptions.IsSortActive)
                    column.ToggleSortDirection();

                column.columnOptions.IsSortActive = true;
            }

            store.PortfolioActions.loadPreventiveActivities();
        }
    }
}

export { PreventiveActivitiesInboxHandler };
